import imageSrc from 'images/articles/logo.png';

/**
 *  Array objects of articles
 *  object contain:
 *  @param path{string}       - relative path in url (/blog/${path}), for example, 'my-best-article'
 *                              YOUR ARTICLE SHOULD BE NAMED JUST LIKE THE PATH
 *  @param title{string}      - title of article in preview
 *  @param nickname{string}   - nickname of author of article
 *  @param label{string|array}- label or labels for articles
 *  @param image{picture}     - image of article on blog preview
 *  @param isAvailable{bool}  - show/hide on page, by default is true
 *  @param date{object}       - Date js object, for example, new Date(2018, 1, 1) => Thu Feb 01 2018,
 *                              https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
 * */
const articles = [{
  path: 'example-my-best-path',
  title: 'Example My Best Title',
  nickname: 'savtym',
  label: ['JavaScript', 'Python'],
  image: imageSrc,
  date: new Date(2018, 1, 1, 17, 30),
}];

export default articles;



// WEBPACK FOOTER //
// ./src/config/articles.js